import React from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';
import CommonButton from '@src/new-components/Button';
import LimitedInput from '@src/new-components/Input/LimitedInput';
import { COLOR } from '@src/styles/color';
import { convertFormatDate } from '@src/utils/date';
import { MAX_TEXT_LENGTH } from '../../constants';
import { StyledConfirmCancellation } from './index.style';

const ConfirmCancellation = ({
  packageExpiryDate,
  feedbackText,
  isSubmitting,
  onFeedbackChange,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <StyledConfirmCancellation>
      <div className="confirm-header">
        <h2 className="confirm-title">{t('confirmCancelTitle')}</h2>
        <p className="confirm-description">
          <Trans
            i18nKey="confirmCancelDescription"
            values={{ expiryDate: convertFormatDate(packageExpiryDate) }}
            components={[<span />, <span className="expiry-date" />]}
          />
        </p>
      </div>

      <div className="feedback-section">
        <LimitedInput
          label={t('feedbackLabel')}
          placeholder={t('feedbackPlaceholder')}
          value={feedbackText}
          onChange={(e) => onFeedbackChange(e.target.value)}
          maxLength={MAX_TEXT_LENGTH}
          multiline
          rows={4}
          showCounter
          disabled={isSubmitting}
        />
      </div>

      <div className="cta-row">
        <CommonButton
          variant="contained"
          onClick={onConfirm}
          disabled={isSubmitting || !feedbackText?.trim()}
          startIcon={
            isSubmitting ? <CircularProgress size={16} color="info" /> : null
          }
          customStyle={{
            height: '48px',
            padding: '0 24px',
            background: COLOR.yellow.default,
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 600,
            letterSpacing: '-0.4px',
            color: COLOR.darkBlue,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            boxShadow: 'none',
            '&:hover': { background: COLOR.yellow.default, boxShadow: 'none' },
          }}
        >
          {t('cancelAutoRenewConfirmButton')}
        </CommonButton>
      </div>
    </StyledConfirmCancellation>
  );
};

export default ConfirmCancellation;
